import { ClickAwayListener, Fade, Popper } from '@material-ui/core'
import { ReactNode } from 'react'
import { SetState } from 'types'

interface GenericContentPopperProps {
  open: boolean
  anchorEl: HTMLElement
  setAnchorEl: SetState<HTMLElement | null>
  children: ReactNode
  style?: React.CSSProperties | undefined
}

export const GenericContentPopper = ({
  open,
  anchorEl,
  setAnchorEl,
  children,
  style,
}: GenericContentPopperProps): JSX.Element => {
  return (
    <ClickAwayListener
      onClickAway={() => {
        setAnchorEl(null)
      }}
    >
      <Popper open={open} anchorEl={anchorEl} transition style={style}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className="custom-genericPopper">{children}</div>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  )
}
